import { compose, hoistStatics, lifecycle, withState, withPropsOnChange, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Reactions from './Reactions';
import EmotionService from '../../services/emotions.service';

const getImageCount = props => (type) => {
  let searchedObject = props.data.emotions.find((o) => {
    if (parseInt(o.type, 10) === parseInt(type, 10)) {
      return o;
    }
  });
  if (!searchedObject) {
    searchedObject = { type: parseInt(type, 10), count: 0 };
  }
  return searchedObject;
};

const mapStateToProps = state => ({
  user: state.user.user,
});

const addReaction = props => async (e, id) => {
  e.preventDefault();
  if (!props.user) return props.history.push('/login');
  const { model_id, model_name, setData, data, emojiSrc } = props;
  const userLastEmo = data.userEmotion && data.userEmotion[0] ? parseInt(data.userEmotion[0].type, 10) : -1;
  const newEmotions = Object.keys(emojiSrc).map((emo) => {
    const { count } = getImageCount(props)(emo);
    if (parseInt(emo, 10) === userLastEmo) {
      return { type: parseInt(emo, 10), count: count - 1 };
    }
    else if (parseInt(emo, 10) === parseInt(id, 10)) {
      return { type: parseInt(emo, 10), count: count + 1 };
    }
    return { type: parseInt(emo, 10), count };
  });
  const userEmotion = userLastEmo === parseInt(id, 10) ? [] : [{ type: parseInt(id, 10) }];
  setData({ emotions: newEmotions, userEmotion });
  await EmotionService.update({ model_id, model_name, type: id });
};

const enhance = compose(
  connect(mapStateToProps, null),
  withState('isLoading', 'setIsLoading', true),
  withState('emojiSrc', 'setEmojiSrc', null),
  withState('data', 'setData', null),
  withPropsOnChange(['model_id', 'model_name'], async (props) => {
    const { model_id, setData, model_name } = props;
    const { data } = await EmotionService.getData({ model_id, model_name });
    setData(data);
  }),
  lifecycle({
    async componentDidMount() {
      const { setEmojiSrc, setIsLoading } = this.props;
      const emojiSrc = await EmotionService.getEmojiSrc;
      setEmojiSrc(emojiSrc);
      setIsLoading(false);
    },
  }),
  withHandlers({
    addReaction,
    getImageCount,
  }),
);

export default withRouter(hoistStatics(enhance)(Reactions));



// WEBPACK FOOTER //
// ./src/components/reactions/index.js